module.exports = __webpack_public_path__ + "core-img/loading_overlay.ac6e58aba1cec1efc305c0d73868723a.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/loading_overlay.png
// module id = 35
// module chunks = 0